<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="save")
    modal(
      active,
      title="Confirmar Vistoria com Outro Fiscal",
      @close="$emit('close')"
    )
      div(slot="modal-body")
        .columns
          form-group.column.col-12(
            :label="'ordem_servico.usuario_responsavel' | tModel",
            :validation="$v.form.usuario_responsavel_id"
          )
            fiscal-picker(v-model="$v.form.usuario_responsavel_id.$model")
          form-group.column.col-12(
            :label="'ordem_servico.situacao' | tModel",
            :validation="$v.form.situacao"
          )
            select-ordem-servico-situacao(
              v-model="$v.form.situacao.$model",
              :situacoes="allowedSituacoes"
            )
          form-group.column.col-12(
            label="Informe o motivo para vistoria por outro fiscal",
            :validation="$v.form.motivo"
          )
            textarea.form-input(v-model="$v.form.motivo.$model", rows="4")
      .text-right(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid") Salvar
</template>

<script>
import { deepClone, sanitize } from "paliari-js-utils"
import { required, minLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

export default {
  vuex: {
    servicos: {
      actions: ["fetchConfirmarFiscal"],
      getters: ["loading"],
      state: ["current", "status"],
    },
  },
  data() {
    return {
      form: {},
      allowedSituacoes: {
        andamento: "Em andamento",
        em_distribuicao: "Em distribuição",
      },
    }
  },
  computed: {
    protocoloTipos() {
      return this.$i18n.t("enums.db.enum_protocolo_tipo")
    },
  },
  validations: {
    form: {
      usuario_responsavel_id: { required },
      situacao: { required },
      motivo: {
        required,
        minLength: minLength(10),
      },
    },
  },
  methods: {
    save() {
      const { id } = this.current
      const params = { id, ...this.form }
      this.fetchConfirmarFiscal(params)
        .then(() => {
          this.$toaster.success("Confirmado com sucesso")
          this.$emit("close")
        })
        .catch((e) => toastErrors(e))
    },
  },
  created() {
    const rules = {
      id: true,
      usuario_responsavel_id: true,
    }
    this.form = {
      ...sanitize(deepClone(this.current), rules),
      motivo: "",
      situacao: null,
    }
  },
}
</script>
